import { render } from "./recharge-credits.vue?vue&type=template&id=7222413e&scoped=true"
import script from "./recharge-credits.vue?vue&type=script&lang=js"
export * from "./recharge-credits.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7222413e"

export default script